export const baseURL = "https://admin.queenlive.fun/";
export const key = "BS67Rfb0Tf";
